import styled from 'styled-components';
import ScrollableWrapper from '../../../../components/ScrollableWrapper';
import { theme } from '../../../../styles/theme';

export const Container = styled(ScrollableWrapper)`
  width: 100%;
  height: 100%;
  min-height: 400px;
  background: ${theme.colors.level0};
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 4px;
  margin-bottom: 16px;
  padding: 16px;
  border-bottom: 1px solid ${theme.colors.border};
`;

export const HeaderMain = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
`;

export const Title = styled.div`
  font-size: 18px;
  font-weight: 600;
  color: ${theme.colors.secondary900};
`;

export const Description = styled.div`
  font-size: 12px;
  color: ${theme.colors.secondary800};
  margin-top: 4px;
`;

export const HeaderInfo = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  font-size: 12px;
  color: ${theme.colors.secondary800};
`;

export const Content = styled.div`
  padding: 16px;
`;
